module.exports = __webpack_public_path__ + "img/home.e98941e1.png";